<header class="app-header navbar">
  <a
    class="navbar-brand"
    href="#"
    alt="Joinrs Logo"
    aria-label="Joinrs Logo link to home page"
  ></a>
  <button
    class="navbar-toggler d-lg-none"
    type="button"
    appMobileSidebarToggler
    aria-label="Menu Toggle Button"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <button
    class="navbar-toggler d-md-down-none mr-auto"
    type="button"
    appSidebarToggler
    aria-label="Menu Toggle Button"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <!-- <button class="aside-toggler d-md-down-none" type="button" appAsideMenuToggler>
    <span class="aside-toggler-icon"></span>
  </button> -->
  <div class="row mr-1">
    <div class="col text-right">
      <span class="font-weight-normal"
        >{{ operator?.name }} {{ operator?.surname }}<br />{{
          operator?.email
        }}</span
      >
    </div>
  </div>
</header>
